import GuessFestival from "../../components/Nursery/GeneralAwareness/GuessFestival";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


document.title = "Mamas Guidance - Nursery - General Awareness - Festivals"; // Set page title


const topics: MenuItem[] = [
    { url: "/nursery/general-awareness/festivals/guess-festival", title: "Guess Festivals", component: GuessFestival},
    // { url: "/nursery/general-awareness/festivals/match-home-items", title: "Match Home Items"},
];


export default topics;